// Body of the Oscar account-profile (display) view: the legacy sealy account
// landing -- the "Your Account" welcome header, the Your Orders / Your
// Addresses cards, the account-information list with the password-management
// links, and the customer-service info block. Copy is hardcoded English like
// the legacy page's resolved output (sealy configures only en-us, so its
// {% trans %} blocks always rendered the msgid).
import { Immutable } from "immer";
import React from "react";
import { useStaticURL } from "tsi-common-react/src/utils/urls";

import { templates } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { CustomerServiceInfoBlock } from "../CustomerServiceInfoBlock";

import styles from "./index.module.scss";

type IProps = Immutable<templates.ProfileDocumentTemplate>;

export const ProfilePageBody = (props: IProps): React.JSX.Element => {
    const staticURL = useStaticURL();
    return (
        <>
            <section
                className={concatClassNames([
                    "account-profile",
                    styles.accountProfile,
                ])}
            >
                <div className="l-capped-width">
                    <header>
                        <h2>Your Account</h2>
                        <p>
                            Welcome to your Sealy® Account. Here you can access
                            your order history, track shipments, manage your
                            address book and more.
                        </p>
                    </header>

                    <div className={styles.accountProfileCard}>
                        <img
                            src={`${staticURL}img/icons/badge-orders.png`}
                            alt=""
                        />
                        <h3>Your Orders</h3>
                        <p>Track, review, and update order status</p>
                        <a href={props.order_list_url}>View details</a>
                    </div>

                    <div className={styles.accountProfileCard}>
                        <img
                            src={`${staticURL}img/icons/badge-addresses.png`}
                            alt=""
                        />
                        <h3>Your Addresses</h3>
                        <p>View and edit your saved addresses</p>
                        <a href={props.address_list_url}>View details</a>
                    </div>

                    <div className={styles.accountProfileInfo}>
                        <h2>Account Information</h2>
                        <dl>
                            <div>
                                <dt>Name</dt>
                                <dd>{props.full_name}</dd>
                            </div>
                            <div>
                                <dt>Email</dt>
                                <dd>{props.email}</dd>
                            </div>
                            <div>
                                <dt>Date Registered</dt>
                                <dd>{props.date_registered_short}</dd>
                            </div>
                        </dl>

                        {props.is_sso ? (
                            <p>{props.sso_message}</p>
                        ) : (
                            <>
                                <a
                                    className="link"
                                    href={props.profile_update_url}
                                >
                                    Edit Profile
                                </a>{" "}
                                |{" "}
                                {props.has_password ? (
                                    <a
                                        className="link"
                                        href={props.change_password_url}
                                    >
                                        Change Password
                                    </a>
                                ) : (
                                    <a
                                        className="link"
                                        href={props.register_url}
                                    >
                                        Create Password
                                    </a>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </section>

            {props.cs_info && <CustomerServiceInfoBlock info={props.cs_info} />}
        </>
    );
};
